/**
 * @generated SignedSource<<0cd3eb316b206054b46f169acf756149>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerSecuredVariables_info$data = {
  readonly name: string;
  readonly platform: string;
  readonly uid: string;
  readonly " $fragmentType": "OwnerSecuredVariables_info";
};
export type OwnerSecuredVariables_info$key = {
  readonly " $data"?: OwnerSecuredVariables_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerSecuredVariables_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerSecuredVariables_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "60eb4d5a263479d52047ae6aaf52be87";

export default node;
